{
  "name": "MyGPhCAdmin.Web",
  "version": "0.0.236",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "concurrently --kill-others \"npm run watch:scss\" \"ng serve --port=44326 --configuration=local-sit\"",
    "start-local": "concurrently --kill-others \"npm run watch:scss\" \"ng serve --port=44326 --configuration=local\"",
    "start-dev": "concurrently --kill-others \"npm run watch:scss\" \"ng serve --port=44326 --configuration=dev\"",
    "local-uae": "concurrently --kill-others \"npm run watch:scss\" \"ng serve --port=44326 --configuration=local-uae\"",
    "local-ppd": "concurrently --kill-others \"npm run watch:scss\" \"ng serve --port=44326 --configuration=local-ppd\"",
    "local-sit": "concurrently --kill-others \"npm run watch:scss\" \"ng serve --port=44326 --configuration=local-sit\"",
    "build": "npm run build:scss && ng build",
    "build:scss": "sass --style=compressed --quiet src/app/style/global-styles.scss src/assets/dist.min.css",
    "watch:scss": "sass --style=compressed --silence-deprecation=mixed-decls --watch src/app/style/global-styles.scss:src/assets/dist.min.css",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "resolutions": {
    "natives": "1.1.3"
  },
  "dependencies": {
    "@angular/animations": "^21.2.22",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.22",
    "@angular/compiler": "^21.2.22",
    "@angular/core": "^21.2.22",
    "@angular/forms": "^21.2.22",
    "@angular/material": "^21.2.14",
    "@angular/platform-browser": "^21.2.22",
    "@angular/platform-browser-dynamic": "^21.2.22",
    "@angular/router": "^21.2.22",
    "@azure/msal-angular": "^3.0.21",
    "@azure/msal-browser": "^3.18.0",
    "@types/lodash-es": "^4.17.12",
    "core-js": "^3.45.1",
    "intl": "^1.2.5",
    "jsonfile": "^6.1.0",
    "lodash-es": "^4.17.21",
    "popper.js": "^1.16.1",
    "run-sequence": "^2.2.1",
    "rxjs": "^7.8.1",
    "rxjs-compat": "^6.6.7",
    "squire-rte": "^1.11.3",
    "stacktrace-js": "^2.0.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.22",
    "@angular/cli": "^21.2.22",
    "@angular/compiler-cli": "^21.2.22",
    "@angular/language-service": "^21.2.22",
    "@types/jasmine": "~5.1.9",
    "@types/jasminewd2": "~2.0.10",
    "@types/node": "^24.5.2",
    "codelyzer": "^6.0.2",
    "gulp": "^4.0.2",
    "gulp-bump": "^3.2.0",
    "gulp-shell": "^0.8.0",
    "gulp-util": "^3.0.8",
    "jasmine-core": "~5.10.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-cli": "~2.0.0",
    "karma-coverage-istanbul-reporter": "^3.0.3",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "protractor": "~7.0.0",
    "sass": "^1.93.1",
    "semver": "^7.7.2",
    "ts-node": "^10.9.2",
    "tslint": "~6.1.3",
    "typescript": "~5.9.0",
    "vinyl-ftp": "^0.6.1"
  }
}
